import { getTvObject } from '@costar-ui/cosmos';

var spacingOptions = getTvObject({
  gap: {
    none: 'gap-0',
    xxs: 'gap-px',
    xs: 'gap-0.5',
    sm: 'gap-1',
    md: 'gap-1.5',
    lg: 'gap-2',
    xl: 'gap-2.5',
    '2xl': 'gap-3',
    '3xl': 'gap-4',
    '4xl': 'gap-6',
    '5xl': 'gap-8'
  },
  gapCol: {
    none: 'gap-x-0',
    xxs: 'gap-x-px',
    xs: 'gap-x-0.5',
    sm: 'gap-x-1',
    md: 'gap-x-1.5',
    lg: 'gap-x-2',
    xl: 'gap-x-2.5',
    '2xl': 'gap-x-3',
    '3xl': 'gap-x-4',
    '4xl': 'gap-x-6',
    '5xl': 'gap-x-8'
  },
  gapRow: {
    none: 'gap-y-0',
    xxs: 'gap-y-px',
    xs: 'gap-y-0.5',
    sm: 'gap-y-1',
    md: 'gap-y-1.5',
    lg: 'gap-y-2',
    xl: 'gap-y-2.5',
    '2xl': 'gap-y-3',
    '3xl': 'gap-y-4',
    '4xl': 'gap-y-6',
    '5xl': 'gap-y-8'
  },
  padding: {
    none: 'p-0',
    xxs: 'p-px',
    xs: 'p-0.5',
    sm: 'p-1',
    md: 'p-1.5',
    lg: 'p-2',
    xl: 'p-2.5',
    '2xl': 'p-3',
    '3xl': 'p-4',
    '4xl': 'p-6',
    '5xl': 'p-8'
  },
  paddingX: {
    none: 'px-0',
    xxs: 'px-px',
    xs: 'px-0.5',
    sm: 'px-1',
    md: 'px-1.5',
    lg: 'px-2',
    xl: 'px-2.5',
    '2xl': 'px-3',
    '3xl': 'px-4',
    '4xl': 'px-6',
    '5xl': 'p-8'
  },
  paddingY: {
    none: 'py-0',
    xxs: 'py-px',
    xs: 'py-0.5',
    sm: 'py-1',
    md: 'py-1.5',
    lg: 'py-2',
    xl: 'py-2.5',
    '2xl': 'py-3',
    '3xl': 'py-4',
    '4xl': 'py-6',
    '5xl': 'py-8'
  },
  margin: {
    none: 'm-0',
    xxs: 'm-px',
    xs: 'm-0.5',
    sm: 'm-1',
    md: 'm-1.5',
    lg: 'm-2',
    xl: 'm-2.5',
    '2xl': 'm-3',
    '3xl': 'm-4',
    '4xl': 'm-6',
    '5xl': 'm-8'
  },
  marginX: {
    none: 'mx-0',
    xxs: 'mx-px',
    xs: 'mx-0.5',
    sm: 'mx-1',
    md: 'mx-1.5',
    lg: 'mx-2',
    xl: 'mx-2.5',
    '2xl': 'mx-3',
    '3xl': 'mx-4',
    '4xl': 'mx-6',
    '5xl': 'mx-8'
  },
  marginY: {
    none: 'my-0',
    xxs: 'my-px',
    xs: 'my-0.5',
    sm: 'my-1',
    md: 'my-1.5',
    lg: 'my-2',
    xl: 'my-2.5',
    '2xl': 'my-3',
    '3xl': 'my-4',
    '4xl': 'my-6',
    '5xl': 'my-8'
  }
});

export { spacingOptions as default };
//# sourceMappingURL=spacing-options.esm.js.map
